import { gql } from "@apollo/client";

export function buildBatchDeleteAccountsMutation(ids: string[]) {
  const fields = ids
    .map(
      (id, i) => `
      delete_${i}: deleteAccount(id: "${id}") {
        success
      }
    `
    )
    .join("\n");

  return gql`
    mutation {
      ${fields}
    }
  `;
}

export function buildBatchDeleteContactsMutation(ids: string[]) {
  const fields = ids
    .map(
      (id, i) => `
      delete_${i}: deleteContact(id: "${id}") {
        success
      }
    `
    )
    .join("\n");

  return gql`
    mutation {
      ${fields}
    }
  `;
}

export function buildBatchDeleteDealsMutation(ids: string[]) {
  const fields = ids
    .map(
      (id, i) => `
      delete_${i}: deleteDeal(id: "${id}") {
        success
      }
    `
    )
    .join("\n");

  return gql`
    mutation {
      ${fields}
    }
  `;
}

export function buildBatchDeleteNotesMutation(
  ids: string[],
  workspaceId: string
) {
  const fields = ids
    .map(
      (id, i) => `
      delete_${i}: deleteNote(id: "${id}", workspaceId: "${workspaceId}") {
        success
      }
    `
    )
    .join("\n");

  return gql`
    mutation {
      ${fields}
    }
  `;
}
